export default "__VITE_ASSET__2e2a8713__"